import { useFilters } from '@/Store/filters'
import { writeObject, readObject, removeObject } from '@/Utils/localstorage'
import { watch } from 'vue'


export const useMemorizeFilters = () => {
    const filtersStore = useFilters()

    const cacheFilters = readObject( 'filters' )

    if ( cacheFilters )
        filtersStore.setState( cacheFilters )

    watch( filtersStore, () => writeObject( 'filters', filtersStore.filters ), { deep: true } )
    
    const clearFiltersComponent = ( componentName, initial = {} ) => filtersStore.clearFilters( componentName, initial )

    const clearFilters = () => {
        filtersStore.clear()
        removeObject( 'filters' )
    }

    const getFiltersComponent = componentName => filtersStore.getComponentFilters( componentName )
    const setFiltersComponent = ( componentName, initial = {} ) => filtersStore.setFilters( componentName, initial )

    return {
        filtersStore,
        clearFiltersComponent,
        getFiltersComponent, 
        setFiltersComponent,
        clearFilters,
    }

} 
